import ManageTeams from './ManageTeams'

export default ManageTeams;